import './CustomTextarea.css';

export default function CustomTextarea({id, value, label, onChange}) {
  return <textarea 
    id={id}
    className={'custom-textarea' + (value === '' ? '' : ' with-value')}
    placeholder={label}
    value={value} onChange={e => onChange(e.target.value)} />;
}